import React from 'react';

/** Loading placeholder for category hub (/shop/:slug) — hero + group cards. */
export default function CollectionHubSkeleton({ count = 4 }) {
  return (
    <div className="collections-page collections-page--v2 collection-hub-skeleton" aria-busy="true" aria-label="Loading collection">
      <div className="container store-page__container">
        <div className="collection-hub-skeleton__hero">
          <div className="catalog-skeleton__line collection-hub-skeleton__line--short" />
          <div className="catalog-skeleton__line collection-hub-skeleton__line--title" />
          <div className="catalog-skeleton__line collection-hub-skeleton__line--subtitle" />
        </div>
        <div className="collection-group-grid collection-hub-skeleton__grid">
          {Array.from({ length: count }, (_, i) => (
            <div key={i} className="collection-hub-skeleton__card">
              <div className="collection-hub-skeleton__media" />
              <div className="catalog-skeleton__line collection-hub-skeleton__line--label" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
